import { featureset } from '@/plugins/featureset.js'

const lodash = require('lodash')

export function featureAvailable (feature) {
  return lodash.hasIn(featureset, feature)
}

export function availableMenuFeatures (menuPlainTree) {
  return lodash.pickBy(menuPlainTree, (value, key) => {
    return featureAvailable(value.feature)
  })
}

export function availableRouterFeatures (routes) {
  return routes.filter((r) => {
    return lodash.has(r, 'feature')
      ? featureAvailable(r.feature)
      : true
  })
}

export function access (feature, requestedPermissions) {
  const appPermissions = lodash.get(featureset, feature + '.crud')
  const permissionsCount = (requestedPermissions.match(new RegExp('[' + appPermissions + ']', 'g')) || []).length
  return permissionsCount === requestedPermissions.length
}
